import './ErrorsPages.scss';

import { ArrowForward} from '@mui/icons-material';
import { Button } from '@mui/material';
import {useNavigate } from 'react-router-dom';

import { DrawIconsError502 } from '../../data/SVGs';
//import useRole from '../hooks/useRole';
import { buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';

const Error502 = () => {

    const navigate = useNavigate();
    //const role=useRole();

    return (
        <div
            className='App-intro'
            style={{height:'100%'}}
        >
            <div className='errorF0'>
                <DrawIconsError502 />
                <div className='errorF1'>
                    <h5
                        className='pricingF25'
                        style={{color:'#272D3C'}}
                    >Page Under Construction</h5>
                    {/* <h6
                        className='pricingF26'
                        style={{color:'#B0B0B0'}}
                    >Try to refresh this page or feel free to contact us if the problem persists.</h6> */}
                </div>
                <div className="flexGrow">
                    <div className="flexGrow">
                        <Button
                            variant='contained'
                            onClick={()=>{
                                //navigate(`/${role}/`,{replace:true});
                                navigate(-1);
                            }}
                            style={{...buttonStylesBlue()}}
                            startIcon={<ArrowForward />}
                        >Homepage</Button>
                    </div>
                </div>
            </div>
            {/*<Footer />*/}
        </div>
        //</article>
    );
};

export default Error502;
